/** Exact typography accepts simple CSS values, never arbitrary CSS expressions or declarations. */
export type PreciseTypography = "font-size" | "line-height" | "letter-spacing";

export function preciseTypographyValue(
  raw: unknown,
  kind: PreciseTypography,
): string | undefined {
  if (typeof raw !== "string") return undefined;
  const value = raw.trim();
  if (kind === "line-height" && /^\d+(?:\.\d+)?$/.test(value)) {
    const number = Number(value);
    return number >= 0.5 && number <= 5 ? value : undefined;
  }
  const pattern =
    kind === "letter-spacing"
      ? /^-?\d+(?:\.\d+)?(?:px|rem|em)$/i
      : /^\d+(?:\.\d+)?(?:px|rem|em|vw|vh|%)$/i;
  return pattern.test(value) &&
    (kind === "letter-spacing" || Number.parseFloat(value) > 0)
    ? value
    : undefined;
}
